/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VideoSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABE0lEQVR4nNWVO07EMBCGLYHgAlByBqQtaSIaFGkzjy2cGU5jOuAq3GBLDkCxd2CRKDkA2tUItIqIsvEjKfilNI71fePEHjv339I09xdIukaW53ngLBtk3ZlkUnjt/eUBzrIx2eGl9/7MlgQkHz8T4p6G5a5X+V+4BVmfUsDIugOShyi4BVi2U8KJ5KZZtYvuCiaDI2v4HfvKEYRjP9Tk3fmpgpACTxWEVHiKIOTAYwUhFx4jKILjMcHYVoQI+KAgG076MiooqdwZB9tbYH3tHTQg+SyBA8u223p6rYJIrkq+OZA+urEMwZer9hpIvocqt05s7T7/siiN9/4ESd9mgTurvq7PkfXdJJPDu5Kqqk7ngO8BVNxBiAUA1fEAAAAASUVORK5CYII=)
 */
export const VideoSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM9.2 20a.5.5 0 0 1-.35-.85l12.1-12.1a.5.5 0 0 1 .12-.09l.48-.24a1 1 0 0 1 1.45.9v8.76a1 1 0 0 1-1.45.9l-3-1.5a1 1 0 0 1-.55-.9V17a3 3 0 0 1-3 3H9.2ZM15.28 4.72c.27-.27.15-.71-.23-.72H4a3 3 0 0 0-3 3v10a3 3 0 0 0 .17.99c.1.3.49.35.72.12l13.4-13.4Z"
        className={colorClass}
      />
    </svg>
  );
};
